"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var PERSONAL_FORMULA_SUCCESS = "PERSONAL_FORMULA_SUCCESS";
var questions = [{
  prompt: "Here is a list of self-care activities. Choose some that you think could work for you, then we’ll look at scheduling them into your diary.",
  type: "radio",
  options: ["Retraining thinking exercises", "Taking actions based on values", "Breathing exercises", "Reading, listening to or watching something uplifting or inspirational", "Using sticky notes or post-it notes with beliefs to remember"],
  batteryId: PERSONAL_FORMULA_SUCCESS,
  meta: {
    summaryTitle: "Your self care activities:"
  }
}, {
  prompt: "What about these?",
  type: "radio",
  options: ["Prayer or spiritual practices", "Exercise", "Healthy meals", "Massage, acupuncture or alternative medicine", "Meeting or calling someone who supports your growth"],
  batteryId: PERSONAL_FORMULA_SUCCESS,
  meta: {
    summaryTitle: "Your self care activities:"
  }
}, {
  prompt: "Last ones...",
  type: "radio",
  options: ["Journalling", "Gratitude", "Random Act of Kindness"],
  batteryId: PERSONAL_FORMULA_SUCCESS,
  meta: {
    summaryTitle: "Your self care activities:"
  }
}, {
  prompt: "Anything else for you personally that I missed?",
  type: "textarea",
  meta: {
    answerLabel: "My self care activities are...",
    summaryTitle: "Your self care activities:",
    placeholderText: ""
  },
  batteryId: PERSONAL_FORMULA_SUCCESS
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;